import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_PermissionProject } from '@nu-art/permissions-shared';
export const dispatch_onPermissionProjectChanged = new ThunderDispatcherV3('__onPermissionProjectUpdated');
export class ModuleFE_PermissionProject_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_PermissionProject, dispatch_onPermissionProjectChanged);
        this._v1 = {};
    }
}
export const ModuleFE_PermissionProject = new ModuleFE_PermissionProject_Class();
//# sourceMappingURL=ModuleFE_PermissionProject.js.map